import React, {useState, useCallback} from "react";

import withStyles from '@material-ui/core/styles/withStyles';
import {
    Create,
    FormTab,
    Edit,
    TextInput,
    TabbedForm,
    AutocompleteInput,
    SelectInput,
    DateInput,
    TopToolbar,
    ReferenceInput,
    Toolbar, SaveButton, DeleteButton,
    useGetOne, Loading, NumberInput, TextField, ShowButton
} from 'react-admin';
import {makeStyles} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
    parametro: {display: 'inline-block', width: 800, marginLeft: 8},
    parametro_path: {display: 'inline-block', width: 800, marginLeft: 8},
    parametro_descripcion: {display: 'inline-block', width: 800, marginLeft: 8},
}));

const ParametroPathEdit = props => {
    const classes = useStyles();


    const PostEditActions = ({basePath, data, resource}) => (
        <TopToolbar>
            <ShowButton basePath={basePath} record={data}/>
        </TopToolbar>
    );

    const redirect = (basePath, id, data) => `/ParametroPath`;

    const CustomToolbar = props => (

        <Toolbar {...props}>
            <SaveButton
                label="Actualizar"
                transform={transform}
                submitOnEnter={false}
                disabled={props.pristine}
            />
            {/*<DeleteButton undoable={false} redirect={redirect}/>*/}
        </Toolbar>
    );
    const transform = data => {
        return {
            ...data
        }
    };

    const PostTitle = ({record}) => {
        return <span>Parametros del Path: {record ? `${record.parametro}` : ''}</span>;
    };

    return (
        <Edit title={<PostTitle/>} actions={<PostEditActions/>} {...props}>
            <TabbedForm
                redirect={redirect}
                toolbar={<CustomToolbar/>}
            >
                {/*Datos*/}
                <FormTab label="DATOS PARAMETRO PATH">

                    <TextInput
                        label="Parametro"
                        source="parametro"
                        formClassName={classes.parametro}
                        placeholder="Ingrese Parametro"
                        helperText="Parametro"
                        margin="normal"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        inputProps={{readOnly: true}}
                    />
                    <br/>

                    <TextInput
                        label="Parametro Path"
                        source="parametro_path"
                        formClassName={classes.parametro_path}
                        placeholder="Ingrese Parametro Path"
                        helperText="Parametro Path"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                    <TextInput
                        label="Parametro Descripcion"
                        source="parametro_descripcion"
                        formClassName={classes.parametro_descripcion}
                        placeholder="Ingrese Parametro Descripcion"
                        helperText="Parametro Descripcion"
                        margin="normal"
                        fullWidth
                        InputLabelProps={{
                            shrink: true,
                        }}
                        variant="outlined"
                    />
                    <br/>

                </FormTab>
            </TabbedForm>
        </Edit>
    )
};
export default ParametroPathEdit;


